export default {
    message: {
        'header': {
            'online': 'En ligne'
        },
        'footer': {
            'home': ' Accueil',
            'points': 'Points',
            'vip_zone': ' Espace VIP',
            'order': 'Commande',
            'account': ' Compte'
        },
        'index': {
            'notice1': " Félicitations au joueur ",
            'notice2': "'s participation, won",
            'notice3': " Félicitons-le !",
            'hot_spot': 'POINT CHAUD',
            'all_goods': 'Toutes les marchandises. ',
            'promotion_type': ' Type de promotion ',
            'partners': ' Partenaires ',
            'announcement': " L'annonce ",
            'cancel': ' Annuler ',
            'travel_to': ' Voyager à ',
            'ok': 'OK'
        },
        'goods': {
            'name1': ' Double remboursement ',
            'name2': ' Espèces x2 retours ',
            'name3': '70 fois remboursement (VIP1)',
            'name4': ' Espèces x 72 retours '
        },
        'img': {
            'banner1': 'https://zhouyaoming.in2015.com//uploads/attach/2021/10/20211015/b1e3c2a662e7333346ef1446db67b4c4.jpeg',
            'banner2': 'https://zhouyaoming.in2015.com//uploads/attach/2021/10/20211015/c9bf70863920f2a2ac53de21510d71c0.jpeg',
            'banner3': 'https://zhouyaoming.in2015.com//uploads/attach/2021/10/20211015/069a377136fa1234618c073b166f7ddd.jpeg',
            'banner4': 'https://manage.im2015.com//uploads/attach/2020/03/20200307/4a31597de7b1cc2674314bd8644415f2.jpg',
            'goods_img_10': 'https://zhouyaoming.in2015.com//uploads/attach/2021/10/20211015/a416c1aa63c2ca77eefa6cd89f376fc0.jpeg',
            'goods_img_50': 'https://zhouyaoming.in2015.com//uploads/attach/2021/10/20211015/5ecd1c7981b5a4b58aed1e761e388ec7.jpeg',
            'goods_img_5': 'https://zhouyaoming.in2015.com//uploads/attach/2021/10/20211015/91e6995aeab9e5642b09289981288bd5.jpeg',
            'goods_img_150': 'https://zhouyaoming.in2015.com//uploads/attach/2021/10/20211015/1d5e4e5c3f6cb2e75a773f2c4bfaf014.jpeg',
            'goods_img_25': 'https://zhouyaoming.in2015.com//uploads/attach/2021/10/20211015/86d508dec4193df34ca3d10ec08eca8b.jpeg',
            'goods_img_500': 'https://zhouyaoming.in2015.com//uploads/attach/2021/10/20211015/81f89dadca780f51c92416a95ee3328c.jpeg',
            'goods_img_1500': 'https://zhouyaoming.in2015.com//uploads/attach/2021/10/20211015/69a61a0dfd4998c560b96500d41f9c5f.jpeg',
            'goods_img_2500': 'https://zhouyaoming.in2015.com//uploads/attach/2021/10/20211015/5f47a07b067b6e3acc27a1e384572a69.jpeg',
            'goods_img_return': 'https://zhouyaoming.in2015.com//uploads/attach/2021/06/20210615/f5c725953f90a25e5111bd5b14d4952f.png'
        },
        'detail': {
            'please_select': ' Veuillez sélectionner ',
            'product_description': ' Description du produit ',
            'check_out': ' Vérifier ',
            'original_price': " Prix d'origine ",
            'inventory': ' Inventaire ',
            'sold': ' Vendu ',
            'tip_start': " Le succès de la promotion peut être amélioré en biens d'une valeur de ",
            'tip_end': ' pièce de monnaie gratuite ',
            'quantity': ' Quantité',
            'total_price': ' Prix total ',
            'win_rate': ' Taux de victoire ',
            'predict_type': ' Type de prédiction ',
            'member_shared': ' Membres partagés recevront ',
            'share_now': ' Partage mnt ',
            'copy_the_link': ' Copier le lien ',
            'send_to_friend': ' Envoyer à un ami ',
            'copy_success': ' Copie réussie ',
            'copy_error': ' Copier erreur '
        },
        'integral': {
            'title': " Zone d'échange de points ",
            'search': ' Rechercher l’information sur le produit ',
            'points': ' Points '
        },
        'vip_zone': {
            'title': ' Liste de produits VIP ',
            'price': ' Prix ',
            'sales_volume': ' Volume des ventes '
        },
        'login': {
            'account_login': ['Account login'],
            'login': 'Login',
            'phone': ' Saisir votre numéro de téléphone ',
            'pwd': ' Remplir votre mot de passe ',
            'no_account': ' Avez-vous un compte existant?',
            'forgot_password': 'Oublier MdP',
            'register': "S'inscrire"
        },
        'reset_pwd': {
            'title': 'Retrieve password',
            'get_verification_code': ' Obtenir le code de vérification',
            'confirm': ' Confirmer',
            'verification_code': ' code de vérification',
            'your_new_pwd': ' Votre nouveau MdP',
            'reload': ' Recharger',
            'msg_phone': ' Saisir votre numéro de téléphone'
        },
        'register': {
            'register_account': 'Enregistrer le compte',
            'account': 'Numéro de téléphone',
            'pwd': 'Connectez-vous le MdP',
            'con_pwd': 'Confirmer le MdP',
            'register': "S'inscrire",
            'tip_account': 'Avez-vous un compte existant ?',
            'by_click': " En cliquant sur s'inscrire, j'accepte Centre commercial intéressant ",
            'privacy_policy': ' Politique de confidentialité',
            'tip_wrong': '*Un numéro de téléphone portable incorrect ne pourra pas utiliser le site Web normalement.',
            'msg_phone': " L'erreur de format de téléphone. "
        },
        'order': {
            'submit_order': 'Soumettre la commande',
            'item': 'Article',
            'payment_method': 'Mode de paiement',
            'pay_via_balance': 'Payer par solde',
            'balance_available': 'Solde disponible',
            'total_price': 'Prix total',
            'total': 'Total',
            'check_out': 'Vérifier',
            'msg_param': 'Le paramètre est erroné',
            'msg_order_field': 'Impossible de charger les données de la commande',
            'msg_select_payment': 'Sélectionner le mode de paiement',
            'tip_create_order': 'Créant la commande...',
            'payment_succeeded': 'Paiement réussi',
            'payment_fail': 'Paiement échoué',
            'order_no': 'N° de commande',
            'order_time': 'Temps de la commande',
            'other': 'Autre',
            'total_amount': 'Montant total',
            'failure_reason': "Raison de l'échec",
            'view_payment_results': 'Afficher les résultats du paiement',
            'payment_failed_to_repay': "Le paiement n'a pas été remboursé",
            'top_up': 'recharger',
            'hot_spot': 'POINT CHAUD',
            'back_home': 'Retour à la maison',
            'msg_create_success': 'Commande créée avec succès',
            'confirm_title': 'Payer',
            'confirm_msg': 'Paiement échoué,',
            'confirm_cancel': 'Annuler',
            'confirm_top_up': 'Recharger',
            'game_odd': 'Impair',
            'game_even': 'Pair',
            'game_title': ' IMPAIR OU PAIR ',
            'game_select_title': ' Sélectionner votre résultat attendu ',
            'game_odd_number': ' Numéro impair ',
            'game_even_number': ' Numéro pair ',
            'game_confirm_selection': 'Confirmer la sélection',
            'game_opening_time': "Heure d'ouverture",
            'game_issue': 'Sujet',
            'game_number': 'Numéro',
            'game_results': 'Résultats',
            'game_submit_err': "erreur:commande_id n'existe pas!",
            'game_choose_least': 'Choisir au moins un !',
            'game_success': 'succès',
            'game_error': 'erreur',
            'game_confirm': 'Confirmer',
            'game_confirm_title': 'message',
            'game_confirm_msg': 'Sûr de sélectionner celui-ci',
            'game_confirm_cancel': 'annuler',
            'chart': 'Graphique',
            'close': 'Fermer',
            'bulls_eye': 'TAUREAUX - OEIL',
            'trend_recent': 'Tendance des 50 dernières périodes',
            'number': 'Numéro',
            'times_without': 'fois sans',
            'bet': 'parier'
        },
        'my_order': {
            'title': 'Ma commande',
            'operated': 'opéré',
            'receive': 'Recevoir',
            'completed': 'Complété',
            'converted': 'Converti',
            'refund': 'Rembourser',
            'item_total_amount': 'Article，Montant total',
            'picking_up': 'Ramasser',
            'redeem_points': 'Échanger des points',
            'processing_pick_up': 'Traitement pour le ramassage',
            'hot_spot': 'POINT CHAUD',
            'view_details': 'Afficher les détails',
            'check_tracking': 'Vérifier l’information de suivi',
            'confirm_receival': 'Confirmer la réception',
            'receipt': 'Reçu',
            'cancel': 'Annuler',
            'confirm_pick_up': "Confirmer l'enlèvement",
            'not_sales': 'Pas encore en vente',
            'sales_failed': 'Ventes échouées',
            'sales_success': 'Ventes réussies',
            'waiting_draw': 'En attente du tirage',
            'bonus_countdown': 'Compte à rebours bonus',
            'redeem_success': 'Rachat réussi',
            'awarded': 'Récompensé',
            'points': 'points',
            'fee': 'Frais',
            'cash': 'espèces',
            'sure': 'Bien-sûr',
            'detail_title': 'Détails sur la commande',
            'detail_copy': 'Copier',
            'detail_order_no': 'N ° de commande',
            'detail_order_time': 'Temps de commande',
            'detail_type_order': 'Type de commande',
            'detail_status_payment': 'Statut de paiement',
            'detail_have_pay': 'Doit payer',
            'detail_did_pay': "N'a pas payé",
            'detail_promotion_status': 'Statut de la promotion',
            'detail_promotion_period': 'Période de promotion',
            'detail_promotion_games': 'Jeux de promotion',
            'detail_opening_time': "Temps d'ouverture",
            'detail_my_choice': 'Mon choix',
            'detail_lottery_numbers': 'numéros de loterie',
            'detail_payment_method': 'Mode de paiement',
            'detail_total_amount': 'Montant total',
            'detail_amount_paid': 'Montant payé',
            'detail_re_order': 'Recommander'
        },
        'user': {
            'account': 'Compte',
            'available_balance': 'Solde disponible',
            'my_points': 'Mes points',
            'active_code': 'Code actif',
            'your_code': 'Saisir votre code',
            'msg_code': "Renseigner le code d'échange'",
            'ok': 'OK',
            'deposit': 'Dépôt',
            'withdraw': 'Retirer',
            'confirm_title': 'Confirmer la modification?',
            'confirm_msg': "Changement d'avatar de l'utilisateur",
            'confirm_cancel': 'Annuler',
            'confirm_ok': 'Confirmer',
            'cancelled': 'Annulé',
            'profile_title': 'Profil utilisateur',
            'profile_manage_account': 'Gérer mon compte',
            'profile_nickname': 'pseudo',
            'profile_real_name': 'vrai nom',
            'profile_email': 'Email',
            'profile_phone': 'Téléphone',
            'profile_password': 'MdP',
            'profile_click_change_password': 'Cliquez sur changer le MdP',
            'profile_save_the_change': 'Enregistrer le changement',
            'profile_log_out': 'Déconnexion',
            'profile_confirm_title': 'Déconnexion',
            'profile_confirm_msg': 'Confirmer la déconnexion?',
            'profile_confirm_cancel': 'Annuler',
            'profile_confirm': 'Confirmer',
            'change_password_title': 'Changer le MdP',
            'change_password_current_pwd': 'Saisir votre MdP actuel',
            'change_password_set_new_pwd': 'Définir votre nouveau MdP',
            'change_password_confirm_new_pwd': 'Confirmer le nouveau MdP',
            'change_password_confirm_change': 'Confirmer le changement',
            'change_password_msg_current_pwd': 'Saisir votre MdP actuel',
            'change_password_msg_new_pwd': ' Saisir votre nouveau MdP',
            'change_password_msg_new_pwd_again': 'Saisir à nouveau votre nouveau MdP',
            'change_password_msg_not_match': ' Le MdP ne correspond pas ',
            'user_rank_title': " Registre d'ouverture de prix ",
            'user_menu_bulletin': ' Bulletin ',
            'user_menu_vip': 'VIP',
            'user_menu_binance_pay': ' Binances Paiement ',
            'user_menu_agent': 'Agent',
            'user_menu_balance_details': ' Détails du solde ',
            'user_menu_lottery_record': ' Registre de loterie',
            'user_menu_service': 'Service',
            'user_menu_about_us': 'À propos de nous'
        },
        'balance_detail': {
            'title': 'Détails du solde',
            'total_amount': 'Montant total',
            'top_up': 'Recharger',
            'accumulated_withdrawal': 'Retrait accumulé',
            'bill_record': 'Registre de la facture',
            'consumption_records': ' Registres de consommation ',
            'recharge_records': ' Registres de recharge',
            'points_center': 'Centre de points',
            'sign_in': 'Connexion pour collecter des points',
            'upgrade_level': 'Améliorer les niveaux pour débloquer plus de jeu！'
        },
        'my_pay': {
            'title': 'Lier l’e-porte-monnaie',
            'phone': 'Téléphone',
            'phone_plac': 'Saisir votre téléphone',
            'binance_id': 'Binance ID',
            'binance_id_plac': 'Saisir Binance ID',
            'pay_nickname': 'Paiement de pseudo',
            'pay_id': 'Paiment ID',
            'pay_id_plac': 'Saisir Paiment ID',
            'tip': 'Assurez-vous que toutes les informations sont correctes, sinon vous ne pourrez pas vous rétracter.',
            'bind': 'Lier ',
            'edit': 'Éditer ',
            'msg_nickname': ' Saisir Paiment pseudo ',
            'confirm_msg': "<b style='color: red'>Note</b>: Paiment pseudo ne peut être modifié qu'une seule fois ! ! !<br> Paiment pseudo:",
            'confirm_title': 'Binance Paiment pseudo Éditer ',
            'confirm_cancel': 'Annuler ',
            'confirm_cancelled': 'Annulé',
            'confirm_confirm': 'Confirmer',
            'msg_phone': 'Saisir le numéro de téléphone',
            'msg_binance_id': 'Saisir Binance ID',
            'msg_binance_id_format': "Erreur de format d'ID Binance",
            'msg_pay_nickname': ' Paiment pseudo',
            'msg_pay_id': ' Saisir Paiment ID',
            'msg_pay_id_format': "Erreur de format d'ID de paiement",
            'msg_pay_id_length': "Erreur de longueur d'ID de paiement",
            'msg_binance_pay': "Binance ID n'est pas un ID de paiement, l'ID de paiement se trouve sur la page de réception.",
            'msg_confirm_title': 'Information de confirmation de paiement Binance',
            'msg_confirm_msg1': 'Votre pseudo de paiement',
            'msg_confirm_msg2': 'Votre ID de paiement',
            'msg_confirm_msg3': 'Remarque : Une fois confirmé, il ne peut pas être délié!',
            'msg_confirm_cancel': 'Annuler',
            'msg_confirm_cancelled': 'Annulé',
            'msg_confirm': 'Confirmer',
            'bind_success_msg': 'Lien réussi, vous obtiendrez'
        },
        'user_bill': {
            'title': 'Détails du solde',
            'all': 'Tout',
            'consumption': 'Consommation',
            'recharge': 'Recharger',
            'income': 'Revenu'
        },
        'user_integral': {
            'title': 'Détails des points ',
            'current_points': 'Points actuels ',
            'accumulated_points': 'Points accumulés ',
            'accumulated_consumption': 'Consommation cumulée ',
            'obtained_today': "Obtenu aujourd'hui",
            'details_points': 'Détails des points ',
            'increase_points': 'Augmenter les points ',
            'points_rewarded_purchasing': "Points récompensés pour l'achat de l'article ",
            'earn_points': 'Gagner des points ',
            'points_rewarded_sign': 'Points attribués pour la connexion quotidienne ',
            'sign_points': 'Points',
            'sign_details': 'Détails ',
            'sign_signed': 'Signé',
            'sign_sign': 'Signer ',
            'sign_accumulated_sign': 'Connexion accumulée ',
            'sign_days': 'jours ',
            'sign_tip2_s': 'Il est dit que le ',
            'sign_tip2_e': "jour de connexion continue aura d'énormes points récompensés, ne pas oublier de vous connecter ~~~",
            'sign_click_load_more': 'Cliquer pour charger plus',
            'sign_success': 'Connexion réussie',
            'sign_awarded': 'Récompensé',
            'sign_sure': 'sûr',
            'sign_cnum': ["zéro", "un", "deux", "trois", "quatre", "cinq", "six", "sept", "huit"],
            'sign_msg_signed': "Connecté aujourd'hui !",
            'detail_title': 'Commande des points',
            'detail_phone': 'Téléphone',
            'detail_payment_method': 'Mode de paiement',
            'detail_pay_with_points': 'Paiment avec des points',
            'detail_available_points': 'Points disponibles',
            'detail_total': 'Total',
            'detail_points': 'Points',
            'detail_check_out': 'Vérifier',
            'pay_points': ' Paiment de points',
            'detail_parameter_wrong': 'Le paramètre est incorrect',
            'detail_failed_data': 'Échec du chargement des données de commande',
            'detail_creating_order': 'Création de la commande...',
            'detail_creating_order_fail': 'Création de la commande échouée',
            'detail_status_title': 'Échange de marchandises réussi ',
            'detail_status_check_mailbox': 'Vérifier votre boîte aux lettres, nous vous livrerons le produit dans les 24 heures ',
            'detail_status_view_order': 'Voir la commande ',
            'detail_status_back_home': 'Retour à la maison ',
            'detail_points_title': 'Détails des points',
            'my_order_points_title': 'Ma commande de points'
        },
        'recharge': {
            'title': 'Soumettre une application de recharge',
            'first_deposit': 'Bonus de premier dépôt',
            'use_binance': 'Utiliser Binance',
            'choose_amount': 'Choisir le montant et continuer',
            'current_balance': 'Remarque : Solde actuel',
            'confirm_top_up': 'Confirmer la recharge',
            'application_details': 'Détails de la demande de recharge',
            'order_number': 'Numéro de commande',
            'application_time': "Temps d'application",
            'top_up_amount': 'Montant du recharge',
            'top_up_status': 'Statut de recharge',
            'reviewing': 'Révision',
            'application_success': 'Application réussie',
            'application_failed': 'Application échouée',
            'msg_bind_binance': 'Lier Binance Pay',
            'msg_minimum_bank': 'Minimum 100 à recharger',
            'msg_minimum_binance': 'Minimum 1 pour recharger',
            'msg_enter_top_up_amount': 'Saisir le montant de la recharge',
            'confirm_title': 'Confirmer les détails du dépôt',
            'confirm_verify_information': 'Vérifier l’information',
            'confirm_tip': "Envoyer de l'argent vers l'un des comptes suivants à l'aide de Binance Pay lié, cliquer sur le ₫ supérieur droit pour afficher le didacticiel.",
            'confirm_our_pay_id': 'Notre Pay ID',
            'confirm_copy': 'Copier',
            'confirm_top_up_amount': 'Montant du recharge',
            'confirm_confirm_top_up': 'Confirmer la recharge',
            'confirm_msg_copy': 'Copie réussie',
            'confirm_msg_enter_amount': 'Saisir le montant à recharger',
            'confirm_transfer_amount': 'Transférer le montant minimum de 1',
            'confirm_alert_mes': 'Confirmer que le paiement binance lié a été utilisé pour nous payer.<b style=\'color: red\'> Attendre 5 à 10 minutes pour arriver. </b>En cas de questions, veuillez contacter le service à la clientèle à temps.',
            'confirm_alert_title': 'Soumettre une demande de recharge',
            'confirm_alert_cancel': 'Annuler',
            'confirm_alert_msg_cancelled': 'Annulé',
            'confirm_alert_confirm': 'Confirmer'
        },
        'withdrawal': {
            'title': 'Retirer',
            'link_now_tip': "Vous n'avez pas encore lié l’e-porte-monnaie, veuillez lier et soumettre à nouveau la demande de retrait.",
            'link_now': ' Lien maintenant ',
            'withdrawal_account': ' Compte de retrait ',
            'phone': ' Téléphone ',
            'binance_id': 'Binance ID',
            'nickname': 'Pseudo',
            'pay_id': 'Pay ID',
            'withdraw_amount': ' Retirer le montant ',
            'balance': 'Solde',
            'processing_fee': 'Frais de traitement',
            'actual_amount': 'Montant réel',
            'msg_withdrawal_account': ' Sélectionner un compte de retrait ',
            'msg_fill_data': 'Remplir les données ',
            'msg_phone': 'Saisir le numéro de téléphone ',
            'msg_binance_id': 'Saisir votre Binance ID',
            'msg_binance_pay_id': 'Saisir votre Binance Pay ID',
            'msg_pay_id_err': ' Erreur de format Pay ID',
            'msg_withdraw_amount': 'Saisir le montant du retrait ',
            'msg_insufficient_balance': ' Solde insuffisant ',
            'msg_mini_withdraw': ' Minimum 160 à retirer ',
            'msg_minimum': 'Minimum',
            'msg_to_withdraw': 'à retirer ',
            'audit_tip': "Le retrait a été soumis, en attente d'examen",
            'audit_sure': 'Sûr'
        },
        'user_vip': {
            'title': 'Centre des membres',
            'able_purchase': "Capable d'acheter l'article à",
            'off': 'désactivé',
            'level_task1': 'Compléter le dépôt de 1USDT et acheter des biens 50 fois pour devenir un VIP !',
            'level_task2': 'Frais de retrait',
            'level_task3': 'Temps de retrait',
            'level_task4': 'H',
            'vip_level_unlocked': 'Niveau VIP débloqué',
            'higher_level_unlocked': 'Niveau supérieur débloqué',
            'vip_upgrade_requirements': 'Exigences de mise à niveau VIP',
            'required_tasks': 'Tâches requises',
            'select_one_below': "Sélectionner l'un des éléments ci-dessous",
            'achieved': 'réalisé',
            'conditions_met': 'conditions non remplies',
            'accumulated_participation': 'participation accumulée au jeu',
            'achieved_top_up': 'Recharge de 50 pièces accumulées',
            'exclusive_coupons': 'coupons exclusifs',
            'more_games': 'plus de jeux',
            'need_recharge': 'Nécessité de recharger 50 pièces'
        },
        'promoter': {
            'title': 'Gestion du promoteur',
            'apply_agency': "Postuler pour l'agence et devenir l'un d'entre nous",
            'become_agent': 'Devenir mandataire',
            'repeatedly_delayed': 'Le téléchargement peut être retardé, attendez un moment et ne cliquez pas à plusieurs reprises！',
            'current_commission': 'Commission actuelle',
            'record': 'enregistrement',
            'profit_yesterday': 'Profit hier',
            'accumulated_withdrawal': 'Retrait accumulé',
            'withdraw': 'retirer',
            'refer_friends': 'Référer des amis',
            'total_agent': 'Agent total',
            'copy_success': 'Copie réussie',
            'copy_error': 'Erreur de copie',
            'promoter_achievements': 'Réalisations du promoteur',
            'promoter_orders': 'Commandes des promoteurs',
            'promoter_ranking': 'Classement du promoteur',
            'commission_ranking': 'Classement des commissions',
            'list_title': "Nombre d'agents",
            'list_number_agents': "Nombre d'agents",
            'list_people': 'peuple',
            'list_date_joined': "Date d'adhésion",
            'list_item': 'élément',
            'order_title': 'Commandes accumulées',
            'order_accumulated_orders': 'Commandes accumulées',
            'order_commission': 'commission',
            'order_time': 'Temps de commande',
            'order_mark': 'marque',
            'commission_title': 'Réalisations du promoteur',
            'commission_accumulated_commission': 'Commission accumulée',
            'commission_available': 'Commission disponible pour retrait',
            'commission_week': 'Nouveaux membres cette semaine',
            'commission_month': 'Nouveaux membres ce mois-ci',
            'commission_achievement': 'Réalisation',
            'commission_rank_title': 'Classement des commissions',
            'commission_rank_current': 'Votre classement actuel',
            'commission_rank_yet': "Vous n'êtes pas encore dans le classement",
            'rank_title': 'Classement du promoteur',
            'cash_record_title': 'Détails sur le retrait de la commission',
            'cash_record_cash_out': "Enregistrement de l'encaissement",
            'user_cash_title': 'Retrait de la Commission',
            'user_cash_not_link': "Vous n'avez pas encore lié l’e-porte-monnaie, veuillez lier et soumettre à nouveau la demande de retrait.",
            'user_cash_link_now': ' Lier maintenant ',
            'user_cash_service_provider': ' Fournisseur de services ',
            'user_cash_select_account': 'Sélectionner un compte de retrait ',
            'user_cash_binance_pay': 'Binance Pay',
            'user_cash_bank_account': ' Compte bancaire ',
            'user_cash_bank_account_pla': ' Remplir votre numéro de compte bancaire ',
            'user_cash_ifsc_pla': 'Remplir votre numéro de compte IFSC ',
            'user_cash_upi_pla': 'Remplir votre numéro de compte UPI ',
            'user_cash_withdraw': ' Retirer ',
            'user_cash_minimum': 'Minimum',
            'user_cash_to_withdraw': 'à retirer ',
            'user_cash_current_commission': 'Commission actuelle disponible pour le retrait ',
            'user_cash_account': ' Compte ',
            'user_cash_account_pla': "Remplir votre nom d'utilisateur alipay",
            'user_cash_current_withdrawal': 'Commission de retrait actuelle',
            'user_cash_to_e_wallet': 'Retirer sur l’e-porte-monnaie ',
            'user_cash_to_balance': 'Retirer sur la solde ',
            'user_cash_insufficient_balance': ' Solde insuffisante',
            'user_cash_data_format': 'données au mauvais format'
        },
        'service': {
            'title': ' Enregistrements de messages ',
            'write_email': 'Ecrivez-nous par Email '
        }
    }
};
